import { Expose, plainToClass } from 'class-transformer';

import { Default } from '@lib/common/decorators';
import { SnSize } from '@lib/common/types';

import { SnIconConfig } from '../types/icon-config.type';

export class SnIcon {
  @Expose()
  public icon: string;

  @Expose()
  public svgIcon: string;

  @Expose()
  public class: string;

  @Expose()
  public fontIcon: string;

  @Expose()
  public template: string;

  @Expose()
  public fontIconUnicode: string;

  @Expose()
  public fontSet: string;

  @Expose()
  @Default('md')
  public size: SnSize;

  public static fromConfig(data: SnIconConfig): SnIcon {
    const config = typeof data === 'string' ? { icon: data } : data;

    return plainToClass(SnIcon, config, { strategy: 'excludeAll' });
  }

  constructor() {}
}
